
define('text!templates/awards_link.html',[],function () { return '<li id="navawards"><a href="/mod/awards/"><span><%=Config.modules.awards.title%></span></a></li>\n';});

